import React from 'react';

import withContext from '../common/withContext';
import ProjectContext from './projectContext';
import './credentials.scss';
import { SdfBox, SdfButton, SdfCard, SdfFlagLayout, SdfFocusPane, SdfIcon } from '@synerg/react-components';

function ConsentPreview({ context, consumerApplication = {}, setShowPreviewModal }) {
	const { projectDetail: { name = '' } } = context;
	const { orgName = 'Your Company' } = consumerApplication;


	return (<div>
		<SdfFocusPane
			visible={true}
			paneType="floating"
			size="lg"
			hideAcceptButton={true}
			hideDismissButton={true}
			onSdfDismiss={() => { setShowPreviewModal(false); }}
			closeable={true}
			className="p-12"
		>
			<div className="m-8 mt-0">
				<SdfCard className="m-8 mt-0 rounded-2xl card-shadow" spacing="loose">
					<div className="flex gap-x-4">
						<SdfIcon className="text-heading-06" icon="alert-info" />
						<div className="text-heading-06 font-black">Your authorization is required</div>
					</div>
					<div className="mx-12 mt-10">
						<SdfBox
							shape="rounded"
							variant="filled"
							spacing="loose"
						>
							<SdfFlagLayout>
								<div slot="graphic" className="settings-icon-container">
									<SdfIcon className="settings-icon" icon="action-view-settings" />
								</div>

								<div slot="supporting-content" className="text-body-03 font-bold">
									{name}
									<div className="text-body-01 font-medium">by {orgName}</div>
								</div>
							</SdfFlagLayout>
						</SdfBox>

						<div className="text-body-02 mt-8">
							Allow read access to your employees’ payroll details that includes earnings, taxes and deduction details.
							<div style={{ borderTop: "1px solid #E3DFDA" }} className="my-3"></div>
							Allow read access to your worker profile which includes personal demographic information, tax IDs, personal addresses, personal communication mechanisms, employment/contracting information and compensation.
							<div style={{ borderTop: "1px solid #E3DFDA" }} className="my-3"></div>
							Allow read access to your company setup that includes company name, company address and company admin contact information.
						</div>
					</div>

					<div className="mt-32 text-right">
						<SdfButton emphasis="secondary" className="mr-6"> I disagree </SdfButton>
						<SdfButton emphasis="primary"> I agree </SdfButton>
					</div>
				</SdfCard>

				<div className="text-body-01 m-8 mt-8">
					By clicking ‘I AGREE’, I am authorizing and instructing ADP to provide my data to the above application. I hereby authorize the use of my data obtained from ADP in accordance with the application’s terms of service agreed to at the time of purchase and with the privacy policy found on the application’s website. Note that application users may be able to perform actions and/or access data that they would otherwise not be authorized to do within ADP systems; please verify access controls with the application owner. I acknowledge that I can always modify these settings and manage other account permissions at any time. I acknowledge and agree that any modifications made will not affect data I have previously authorized ADP to provide to this application. You can always modify this setting and manage other account permissions at any time through the ADP Consent Manager.
				</div>
			</div>
		</SdfFocusPane>
	</div>);
}

export default withContext(ConsentPreview, ProjectContext);
